import 'styled-components';
import { ITheme } from './Themes/interfaces';

// Types
export type { IModalState } from './Components/ModalProvider/ModalProvider';
export type { IconName, FaBrandIconName, FaRegularIconName, FaSolidIconName } from './Components/Icons/Icon';
export type { ISelectProps } from './Forms/Select/SelectObsolete';
export type { DeepPartialTheme } from './hooks/useTheme';
export type { CombineValidation, CustomValidation, IValidationResult, MatchValidation, RequiredValidation, Validation } from './hooks/useValidator';
export type {
  IThemeComponentPartColours,
  IThemeComponentStateColours,
  IThemeComponentColours,
  IThemePalette3Gradients,
  IThemePalette4Gradients,
  IThemePalette5Gradients,
  IThemePalette,
  IThemeComponents,
  IThemeText,
  IThemeColourPalette,
  IThemeProps,
  ITheme
} from './Themes/interfaces';
export type { ReactSelectType, SelectOptionType, IGroupedOption, ISelectOption } from './Forms/Select/selectTypes';

// Components
export { Avatar } from './Components/Avatar/Avatar';
export { Banner } from './Components/Banner/Banner';
export { Button } from './Components/Button/Button';
export { ButtonLink } from './Components/Button/ButtonLink';
export { Card, CardContent, CardFooter, CardHeader, CardLarge, CardSeparator, CardSmall } from './Components/Card/Card';
export { Heading1, Heading2, Heading3, Heading4, Heading5 } from './Components/Heading/Heading';
export { Tooltip } from './Components/Tooltip/Tooltip';
export { TooltipText } from './Components/Tooltip/TooltipText';
export { Carousel, CarouselItem } from './Components/Carousel/Carousel';
export { Logo } from './Components/Logo/Logo';
export { CircularIcon } from './Components/Icons/CircularIcon';
export { NavigationBar, NavigationLink } from './Components/Navigation/Navigation';
export { Notification } from './Components/Notification/Notification';
export { Panel } from './Components/Panel/Panel';
export { OptionButton, OptionRadioButton, OptionStatic } from './Components/OptionButton/OptionButton';
export { Tab, TabStrip } from './Components/Tabs/TabStrip';
export { ValidationErrorMessage } from './Components/Validator/ValidationErrorMessage';
export { ModalProvider, useModalState } from './Components/ModalProvider/ModalProvider';
export { ExchangeFlag, Exchanges } from './Components/ExchangeFlag/ExchangeFlag';
export { Icon, IconNames, FaBrandIconNames, FaRegularIconNames, FaSolidIconNames } from './Components/Icons/Icon';

// Animations
export { LoadingBar } from './Animations/LoadingBar/LoadingBar';

// Forms
export { Form, FormCol, FormGroup, FormGroupSeparator, FormRow } from './Forms/Form/Form';
export { CheckBox } from './Forms/CheckBox/CheckBox';
export { RadioButton, RadioButtonGroup, RadioButtonLabel, RadioButtonLabelSmall } from './Forms/RadioButton/RadioButton';
export { FormControlRegexValidator, FormControlValidator, ValidatorEvent } from './Forms/Form/FormControlValidator';
export { VerificationCode } from './Forms/VerificationCode/VerificationCode';
export {
  Input,
  Input as FormControl,
  FormControlIcon,
  LargeFormControl,
  NumericInput,
  NumericInput as NumericFormControl,
  PasswordInput,
  PasswordInput as PasswordFormControl,
  TextArea
} from './Forms/Input/Input';

export { MultiSelectObsolete, SelectObsolete } from './Forms/Select/SelectObsolete';
export { Select } from './Forms/Select/Select';
export { SelectAsync } from './Forms/Select/SelectAsync';
export { createLoadOptionsFunc, createFilter, useDebounceLoadOptions } from './Forms/Select/selectFilterHelpers';
export { DropdownSearchIndicator, CheckboxOption } from './Forms/Select/SelectComponents';
export { FormLabel } from './Forms/FormLabel/FormLabel';

// Typography
export { Link } from './Typography/Link/Link';
export { Label, Text } from './Typography/Text/Text';

// Charts
export { Spark } from './Charts/Spark/Spark';

// Commons
export { convertChartToLineData } from './common/utils';
export { Size } from './common/size';
export { Variant } from './common/variant';
export { Align } from './common/align';
export { baseFontCss } from './common/mixins';

// Hooks
export { useTestId } from './hooks/useTestId';
export { useTheme } from './hooks/useTheme';
export { useValidator, Validators } from './hooks/useValidator';

// Themes
export { themeAnzDark, themeAnzLight } from './Themes/themeAnz';
export { themeStGeorgeDark, themeStGeorgeLight } from './Themes/themeStGeorge';
export { breakpoint } from './Themes/screensize';
export { themeBaseDark, themeBaseLight } from './Themes/themeBase';
export { themeCmcDark, themeCmcLight } from './Themes/themeCmc';

// https://styled-components.com/docs/api#create-a-declarations-file
// include here so package users get this too
declare module 'styled-components' {
  export interface DefaultTheme extends ITheme {}
}
